import * as React from 'react';
export const IcCallAdd = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.34 15.57l-.72-.75a1.992 1.992 0 00-1.42-.58c-.27 0-.52.05-.77.15-.24.1-.46.25-.65.43l-.7.71c-.09.09-.2.17-.33.22-.12.05-.25.08-.38.08s-.26-.03-.38-.08a1.19 1.19 0 01-.33-.22l-4.24-4.24a1.036 1.036 0 01-.3-.71c0-.13.03-.26.08-.38s.12-.23.22-.33l.71-.7a1.992 1.992 0 00.58-1.42c0-.27-.05-.52-.15-.77-.1-.25-.25-.46-.43-.65l-.71-.71A1.992 1.992 0 005 5.04c-.27 0-.52.05-.77.15-.24.1-.46.25-.65.43l-1 1c-.3.31-.5.7-.56 1.13-.16 1.4-.04 4.74 3.68 8.48s7.08 3.84 8.49 3.72c.43-.06.82-.26 1.13-.56l1-1a1.992 1.992 0 00.58-1.42c0-.27-.05-.52-.15-.77-.1-.24-.25-.46-.43-.65l.02.02zM19 6.99h-2v-2c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1z'
      fill='currentColor'
    />
  </svg>
);
